import {
  NumericSeriesPoint,
  Series,
  SeriesDataService,
  SeriesResponse,
} from 'src/services/SeriesDataService';

interface JoinPageMeta {
  total: number;
}
export type JoinPageSignupsData = Series<NumericSeriesPoint, JoinPageMeta>;

export default class JoinPageSignupsDataService extends SeriesDataService<JoinPageMeta> {
  dataUrl: string;
  initialData: JoinPageSignupsData = {
    meta: {total: 0},
    series: {
      monthSignups: [],
      averageMonthSignups: [],
    },
  };

  constructor(dataUrl: string) {
    super();
    this.dataUrl = dataUrl;
  }

  buildMeta = (meta: JoinPageMeta, index: number, response: SeriesResponse): JoinPageMeta => {
    meta.total += response.series['monthSignups'][index];
    return meta;
  };
}
